import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DateTime } from 'luxon';
import { Constant } from 'src/app/constant/constant';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { environment } from 'src/environments/environment';
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { Router, NavigationEnd } from "@angular/router";

@Component({
  selector: 'calsoft-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
export class ActivityComponent implements OnInit {

  url = '';
  sanitizedUrl = '';

  now: any;
  activities: any[] = [];
  currentPage = 0;
  @Input() pageSize: any;

  @Input() leadActivityListFinal: any;

  @Input() totalSize;
  totalItems = 0;
  isLoading = false;
  hasMore = true;
  @Input() useExternalData = false;

  @Input() page = 0;

  @Input() leadActivityList: any = [];


  @Input() leadid: any;
  crmSettingsData: any;
  leadStop: boolean = false;
  isEmpty: any;
  @Input() spinner: boolean = false;

  @Input() onScrollValue: boolean = true;



  constructor(private datepipe: DatePipe, private crmsettingsService: CrmsettingsService,
    private ecryptService: EcryptServiceService, private leadActivityservice: LeadActivityService,
    private leadActivityService: LeadActivityService, private router: Router

  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });
    this.now = DateTime.now();

  }

  groupedActivities: { date: string; activities: any[] }[] = [];
  sortOrder: string = 'all';
  groupActivities() {
    const grouped = this.activities.reduce((acc, activity) => {
      const date = new Date(activity.date).toDateString();
      acc[date] = acc[date] || [];
      acc[date].push(activity);
      return acc;
    }, {});

    this.groupedActivities = Object.keys(grouped).map(date => ({
      date,
      activities: grouped[date]
    }));
  }
  public serverPath = environment.commonImageApi + '/courseAudio/';

  ngOnInit(): void {

    let leadDetailType: any;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encrypted);
        this.crmSettingsData = JSON.parse(decrypted);

        leadDetailType = this.crmSettingsData.leadDetailType;
      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }

    if (leadDetailType != undefined) {

      this.leadDetailType = leadDetailType;


    }



  }



  leadDetailType: any;

  audioCheck(url) {
    if (!url) {
      return false;
    }

    var lowercaseUrl = url.toLowerCase();
    return lowercaseUrl.endsWith('.mp3') || lowercaseUrl.endsWith('.wav') || lowercaseUrl.endsWith('.ogg');
  }



  trackByFn(index: number, item: any) {
    return item.id || index;
  }


  dateformatshowNew(date: string): string {
    return this.datepipe.transform(date, 'MMM d, yyyy, h:mm a'); // ✅ Add 'yyyy'
  }


  getRelativeFormattwo(date: string): string {

    const inputDate = DateTime.fromFormat(date, 'MMM d, yyyy, h:mm a');

    if (!inputDate.isValid) {
      console.error("Invalid date format:", date);
      return 'Invalid Date';
    }

    const currentDate = DateTime.now().startOf('day');
    const diffDays = Math.floor(inputDate.diff(currentDate, 'days').days);

    if (diffDays === 0) {
      return 'Today';
    } else if (diffDays === -1) {
      return 'Yesterday';
    } else if (diffDays < 32) {
      return Math.abs(diffDays) + ' Days Ago';
    } else {
      return inputDate.toFormat('MMMM d, yyyy');
    }
  }
  getRelativeFormat(date: any): any {
    const dateParts = date?.split(',');
    const dateString = dateParts[0];
    const inputDate = DateTime.fromFormat(dateString, 'MMM d');
    const currentDate = DateTime.now().startOf('day');
    const diffDays = inputDate.diff(currentDate, 'days').days;
    if (diffDays === 0) {
      return 'Today';
    } else if (diffDays === -1) {
      return 'Yesterday';
    } else if (diffDays === 1) {
      return 'Tomorrow';
    } else {
      return Math.abs(diffDays) + ' days ago';
    }
  }


  isSameDay(current: string, compare: string) {
    // return this.datepipe.transform(current, 'MMM d, h:mm a');

    const currentDay = this.datepipe.transform(current, 'yyyy-MM-dd');
    const compareDay = this.datepipe.transform(compare, 'yyyy-MM-dd');

    let isSameDay = currentDay === compareDay;

    console.log();

    return isSameDay;
  }

  dateformatshow(date: string) {

    return this.datepipe.transform(date, 'MMM d, h:mm a');
  }
  @Output() scrollChange = new EventEmitter<void>();

  onScroll() {
    console.log("The emiiting");


    this.scrollChange.emit()

  }

  protected _onDestroy = new Subject<void>();

  sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
